module.exports = __webpack_public_path__ + "442f9e22298114c9b08e0acc48f6b630.svg";